<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span class="text-h6">Page Not Found</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PageNotFound",

  components: {},
  data: () => ({}),
  methods: {},
  computed: {},
};
</script>